const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/RescheduleConfirmationPage.tsx';
import { RouteComponentProps } from 'react-router';
import { useIntl } from 'react-intl';
import * as React from 'react';
import textMap from 'App/pages/appointment/translations';
import { IconClass } from '@cistec/common_web/defs/icons';
import { Page } from '../Page';
import Grid from '@mui/material/Grid';
import { AppointmentTitleRow } from './components/AppointmentTitleRow';
import { AppointmentTimeRow } from './components/AppointmentTimeRow';
import { AppointmentDetailsRow } from './components/AppointmentDetailsRow';
import { AppointmentAddToCalendarRow } from './components/AppointmentAddToCalendarRow';
import { AppointmentLocationRow } from './components/AppointmentLocationRow';
import { AppoinmentButtonsRow } from './components/AppoinmentButtonsRow';
import { GoToAppointmentListButton } from './components/GoToAppointmentListButton';
import { AppointmentMessageRow } from './components/AppointmentMessageRow';
import { useStructuredAppointment } from 'App/store/appointment';

interface IRouteParams {
    termnr: string;
}

export const RescheduleConfirmationPage = (props: {} & RouteComponentProps<IRouteParams>) => {
    const { formatMessage } = useIntl();

    const terminNr = props.match.params.termnr;
    const { data: appointment } = useStructuredAppointment(terminNr);
    if (!appointment) return null;

    return (
        <Page title={formatMessage(textMap.terminUmgebucht)} iconClass={IconClass.Calendar}>
            <Grid container spacing={2}>
                <AppointmentTitleRow appointment={appointment} />
                <AppointmentTimeRow appointment={appointment} />
                <AppointmentDetailsRow appointment={appointment} />
                <AppointmentMessageRow text={formatMessage(textMap.rescheduleConfirmationMessage)} />
                <AppointmentAddToCalendarRow appointment={appointment} />
                <AppointmentLocationRow appointment={appointment} />
                <AppoinmentButtonsRow>
                    <GoToAppointmentListButton />
                </AppoinmentButtonsRow>
            </Grid>
        </Page>
    );
};
